// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import styled from '@emotion/styled'
import React, { PropsWithChildren } from 'react'
import Container from '../../common/container/Container'
import Header from '../../domain/header/Header'

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  padding-bottom: 66px;
`

interface CommonPageWrapperProps {
  title: string
}

export default function CommonPageWrapper({ children, title }: PropsWithChildren<CommonPageWrapperProps>) {
  return (
    <Wrapper>
      <Header title={title} />
      <Container>{children}</Container>
    </Wrapper>
  )
}
